import type { AuthProviderType } from '@terra/shared-authorization';
import { DEFAULT_AUTH_PROVIDER } from '@terra/shared-authorization';
import { getConfigValue } from '../lib/public-env/get-config-value';

const isAuthProviderType = (
  value: string | undefined,
): value is AuthProviderType => {
  return value === 'descope' || value === 'openid' || value === 'local';
};

export function getAuthProviderType(): AuthProviderType {
  const configuredProvider = getConfigValue('NEXT_PUBLIC_AUTH_PROVIDER');
  if (isAuthProviderType(configuredProvider)) {
    return configuredProvider;
  }

  return DEFAULT_AUTH_PROVIDER;
}
